import dayjs from "dayjs";

export const initialEvents = [
  {
    id: "1",
    type: "birthday",
    title: "John Smith Birthday",
    date: "2025-10-05",
    time: "12:00 PM",
    name: "John Smith",
  },
  {
    id: "2",
    type: "meeting",
    title: "Staff Meeting",
    date: "2025-10-05",
    time: "9:00 AM",
  },
  {
    id: "3",
    type: "task",
    title: "Lead Follow-up",
    date: "2025-10-05",
    time: "1:00 PM",
  },
  {
    id: "4",
    type: "anniversary",
    title: "Sarah & Mike Anniversary",
    date: "2025-10-10",
    time: "6:00 PM",
  },
  {
    id: "5",
    type: "birthday",
    title: "Emily Taylor Birthday",
    date: "2025-10-12",
    time: "12:00 AM",
  },
  {
    id: "6",
    type: "meeting",
    title: "Wedding Booking Review",
    date: "2025-10-15",
    time: "10:00 AM",
  },
];

export const eventStyles = {
  Task: {
    backgroundColor: "#e6f4ea",
    borderLeft: "4px solid #52c41a",
    color: "#52c41a",
  },
  Meeting: {
    backgroundColor: "#e6f7ff",
    borderLeft: "4px solid #1890ff",
    color: "#1890ff",
  },
  Birthday: {
    backgroundColor: "#fff0f6",
    borderLeft: "4px solid #eb2f96",
    color: "#eb2f96",
  },
  Anniversary: {
    backgroundColor: "#fffbe6",
    borderLeft: "4px solid #faad14",
    color: "#faad14",
  },
  Call: {
    backgroundColor: "#f0f5ff",
    borderLeft: "4px solid #2f54eb",
    color: "#2f54eb",
  },
  Email: {
    backgroundColor: "#f9f0ff",
    borderLeft: "4px solid #722ed1",
    color: "#722ed1",
  },
  Followup: {
    backgroundColor: "#fff7e6",
    borderLeft: "4px solid #fa8c16",
    color: "#fa8c16",
  },
  Chat: {
    backgroundColor: "#f6ffed",
    borderLeft: "4px solid #52c41a",
    color: "#52c41a",
  },
  WhatsApp: {
    backgroundColor: "#e6fffb",
    borderLeft: "4px solid #13c2c2",
    color: "#13c2c2",
  },
};

export const eventIcons = {
  Task: "📋",
  Meeting: "📅",
  Birthday: "🎂",
  Anniversary: "🎉",
  Call: "📞",
  Email: "✉️",
  Followup: "🔁",
  Chat: "💬",
  WhatsApp: "🟢",
};

export const months = dayjs.months();

export const getYearsArray = (range = 5) => {
  const currentYear = dayjs().year();
  return Array.from({ length: range * 2 }, (_, i) => currentYear - range + i);
};
